import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import booking from "../views/booking";
import contact from "../views/contact";
import medical_history from "../views/medical_history";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/booking",
    name: "booking",
    component: booking,
  },
  // {
  //   path: "/medical-history/:access",
  //   name: "Medical History",
  //   component: medical_history,
  // },
  {
    path: "/medical-history",
    name: "Medical History",
    component: medical_history,
  },
  {
    path: "/contact",
    name: "Contact us",
    component: contact,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
